import { render, staticRenderFns } from "./dui-notification.vue?vue&type=template&id=4ea8b020&"
import script from "./dui-notification.vue?vue&type=script&lang=js&"
export * from "./dui-notification.vue?vue&type=script&lang=js&"
import style0 from "./dui-notification.vue?vue&type=style&index=0&id=4ea8b020&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports